<template>
  <!--  @mouseleave="mouseleave" -->
  <div class="comp-xl-avatar" @click.prevent.stop="mouseenter" :style="{ background: bg === true ? 'rgba(31,35,41,.1)' : 'none' }">
    <template v-if="avatar.url">
      <jw-avatar :size="size">
        <img :alt="avatar.name" :src="avatar.url" />
      </jw-avatar>
    </template>
    <template v-else>
      <jw-avatar :size="size" :style="{ backgroundColor: color }">
        <span>{{ avatar?.name?.slice(avatar.name.length - 2) }}</span>
      </jw-avatar>
    </template>

    <span class="jw-avatar-name ellipsis-content" v-if="hasName" :title="avatar.name">{{ avatar.name }}</span>
  </div>
</template>

<script setup>
import useFeishuSDK from '@/hooks/feishu-sdk.js';
import { nextTick, computed } from 'vue';
import { feishuService } from '@/api/';
import { useUserStore } from '@/store';
import { Message } from '@arco-design/web-vue';
const userStore = useUserStore();
const props = defineProps({
  avatar: {
    type: Object,
    default() {
      return {};
    }
  },
  size: {
    type: Number,
    default: 32
  },
  hasName: {
    type: Boolean,
    default: true
  },
  bg: {
    type: Boolean
  },
  hasCard: {
    type: Number
  }
});
const colors = ['#f53f3f', '#7816ff', '#00b42a', '#165dff', '#ff7d00', '#eb0aa4', '#7bc616', '#ffb400', '#b71de8', '#0fc6c2'];
const color = computed(() => {
  let id = props.avatar?.id;
  if (id) {
    id = id + '';
    const i = id.substr(-1, 1);
    return colors[i];
  } else {
    return false;
  }
});
// var leaveTimer;
// const mouseleave = (e) => {
//   timer && clearTimeout(timer);
//   leaveTimer = setTimeout(async () => {
//     closeProfile(e);
//   }, 700);
// };
const closeProfile = () => {
  // if (!(e?.target?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1)) {
  window.removeProfileDynamical?.();
  const dom = document.querySelector('#userProfile');
  dom.innerHTML = '';
  nextTick(() => {
    window.removeProfileDynamical?.();
    dom.innerHTML = '';
  });
  // }
};
// feishu sdk
// var timer = null;
const mouseenter = async (e) => {
  console.log(77, e);

  // timer && clearTimeout(timer);
  // leaveTimer && clearTimeout(leaveTimer);
  let dom = '';
  if (e?.target?.className?.indexOf('comp-xl-avatar') > -1) dom = e?.target;
  if (e?.target?.parentNode?.className?.indexOf('comp-xl-avatar') > -1) dom = e?.target.parentNode;
  if (e?.target?.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1) dom = e?.target?.parentNode?.parentNode;
  if (e?.target?.parentNode?.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1) dom = e?.target?.parentNode?.parentNode?.parentNode;
  console.log(76, dom);
  if (props.hasCard === 0) return;
  const userId = props.avatar?.id;
  console.log('人员组件接受', userId, props);
  if (userId) {
    // 获取当前用户的飞书openId
    if (!userStore.userInfo?.feishuOpenId) return false;
    // 获取用户的openId
    const viewUser = await feishuService.getUserOpenId({ userId });
    if (!viewUser.result) {
      Message.warning('Ta不是飞书成员，无法查看飞书名片');
      return false;
    }
    // 获取用户的openId
    const openId = viewUser.result?.openId;
    console.log(301, openId, viewUser.result);
    closeProfile();
    await useFeishuSDK({ isComponent: 1, userId, openId });
    const dom = document.querySelector('#userProfile');
    var top = e.y;
    var left = e.x;
    // 宽度：
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // 高度：
    var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    if (w - e.x < 320) {
      left -= 320;
    }
    if (h - e.y < 520) {
      top -= 520;
    }
    if (left < 0) left = 0;
    if (top < 0) top = 0;
    left += 30;
    dom.style.left = left + 'px';
    if (h - e.y > 0) {
      dom.style.top = top + 'px';
    } else {
      dom.style.bottom = 0 + 'px';
    }
    // window.removeProfileDynamical?.();
    window.removeProfileDynamical?.();
    nextTick(() => {
      window.addProfileDynamical?.();
    });
  }
  // }, 800);
};

//监听事件
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
eventListener('click', closeProfile, document);
</script>
<style scoped lang="less">
@import './xl-avatar.less';
</style>
